function initializeGuideForCompanyPopup() {
  const path = location.pathname;
  const isForCompanyPage = path.match(/for_company/);
  if (!isForCompanyPage && !Cookies.get("accessed_to_activo")) {
    $.ajax({
      url: Routes.async_info_guide_for_company_path(),
      type: "POST",
      dataType: "script",
    });
    $(document).on("click", ".modalCloseOnClick", () => {
      $("#newCompanyVisitorModal").remove();
    });
  }
  Cookies.set("accessed_to_activo", "done", { expires: 200 });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeGuideForCompanyPopup;